// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Space+Grotesk:wght@300..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(
    circle,
    hsla(0, 0%, 0%, 0.1) 1px,
    transparent 1px
  );
  background-size: 5px 5px;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  padding-inline: 7vw;
  padding-block: 5vh;
  gap: 1.5vh;
}

.body-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(
    circle,
    hsla(0, 0%, 0%, 0.1) 1px,
    transparent 1px
  );
  background-size: 5px 5px;
}

.highlight {
  position: absolute;
  pointer-events: none; /* Permite que eventos do mouse passem pelo highlight */
  width: 300px; /* Tamanho da área de destaque */
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(184, 51, 245, 0.2) 0%,
    rgba(184, 51, 245, 0) 60%,
    transparent 100%
  );
  transition: transform 0.05s ease-out; /* Suaviza o movimento do destaque */
  display: none; /* Inicialmente escondido */
  z-index: 999;
}

.badge {
  width: fit-content;
  padding-inline: 25px;
  padding-block: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 25px !important;
  border-width: 2px;
  border-style: solid;
  border-color: #FF6600;
  background-color: white;
  cursor: pointer;
}

.badge:hover {
    box-shadow: inset 0px -4px 10px #a72fcf33; /* Sombra interna na parte inferior */
}

.home-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.home-btn{
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background-color: #FF6600;
    padding-inline: 13px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Gabarito", sans-serif;
}

.home-btn:hover {
    background-color: #a72fcf;
}

.home-btn-out {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding-inline: 13px;
  padding-block: 8px;
  border-radius: 25px;
  font-size: 14px;
  background-color: white;
  border-color: #FF6600;
  border-width: 1.8px;
  border-style: solid;
  color: #FF6600;
  font-family: "Gabarito", sans-serif;
  position: relative; /* Necessário para o ::before */
  overflow: hidden; /* Esconde a faixa fora do botão */
}

.home-btn-out::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    #3f5efb31,
    transparent
  );
  top: 0;
  left: -100%;
  animation: slide-sash 2s infinite;
}

@keyframes slide-sash {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: -100%;
  }
}

.dash-container{
    width: 100%;
    max-width: 750px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.dash-image{
    width: 100%;
    height: auto;
}

.feature-icon-container {
  padding: 10px;
  background-image: linear-gradient(90deg, #FF6600, #3f5efb);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

th {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #FF6600;
}

td {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #272727;
}

.iconpop:hover {
  opacity: 0.6;
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/Components/style/home.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB;;;;GAIC;EACD,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB;;;;GAIC;EACD,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB,EAAE,uDAAuD;EAC7E,YAAY,EAAE,gCAAgC;EAC9C,aAAa;EACb,kBAAkB;EAClB;;;;;GAKC;EACD,oCAAoC,EAAE,oCAAoC;EAC1E,aAAa,EAAE,2BAA2B;EAC1C,YAAY;AACd;;AAEA;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;IACI,yCAAyC,EAAE,qCAAqC;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,kBAAkB,EAAE,+BAA+B;EACnD,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,MAAM;EACN,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gabarito:wght@400..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Space+Grotesk:wght@300..700&display=swap\");\n\n.body-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  background: radial-gradient(\n    circle,\n    hsla(0, 0%, 0%, 0.1) 1px,\n    transparent 1px\n  );\n  background-size: 5px 5px;\n}\n\n.main-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 1200px;\n  padding-inline: 7vw;\n  padding-block: 5vh;\n  gap: 1.5vh;\n}\n\n.body-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  background: radial-gradient(\n    circle,\n    hsla(0, 0%, 0%, 0.1) 1px,\n    transparent 1px\n  );\n  background-size: 5px 5px;\n}\n\n.highlight {\n  position: absolute;\n  pointer-events: none; /* Permite que eventos do mouse passem pelo highlight */\n  width: 300px; /* Tamanho da área de destaque */\n  height: 300px;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    rgba(184, 51, 245, 0.2) 0%,\n    rgba(184, 51, 245, 0) 60%,\n    transparent 100%\n  );\n  transition: transform 0.05s ease-out; /* Suaviza o movimento do destaque */\n  display: none; /* Inicialmente escondido */\n  z-index: 999;\n}\n\n.badge {\n  width: fit-content;\n  width: fit-content;\n  padding-inline: 25px;\n  padding-block: 2px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border-radius: 25px !important;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #FF6600;\n  background-color: white;\n  cursor: pointer;\n}\n\n.badge:hover {\n    box-shadow: inset 0px -4px 10px #a72fcf33; /* Sombra interna na parte inferior */\n}\n\n.home-btn-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.home-btn{\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n    background-color: #FF6600;\n    padding-inline: 13px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: \"Gabarito\", sans-serif;\n}\n\n.home-btn:hover {\n    background-color: #a72fcf;\n}\n\n.home-btn-out {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding-inline: 13px;\n  padding-block: 8px;\n  border-radius: 25px;\n  font-size: 14px;\n  background-color: white;\n  border-color: #FF6600;\n  border-width: 1.8px;\n  border-style: solid;\n  color: #FF6600;\n  font-family: \"Gabarito\", sans-serif;\n  position: relative; /* Necessário para o ::before */\n  overflow: hidden; /* Esconde a faixa fora do botão */\n}\n\n.home-btn-out::before {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    #3f5efb31,\n    transparent\n  );\n  top: 0;\n  left: -100%;\n  animation: slide-sash 2s infinite;\n}\n\n@keyframes slide-sash {\n  0% {\n    left: -100%;\n  }\n  50% {\n    left: 100%;\n  }\n  100% {\n    left: -100%;\n  }\n}\n\n.dash-container{\n    width: 100%;\n    max-width: 750px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.dash-image{\n    width: 100%;\n    height: auto;\n}\n\n.feature-icon-container {\n  padding: 10px;\n  background-image: linear-gradient(90deg, #FF6600, #3f5efb);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nth {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  color: #FF6600;\n}\n\ntd {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  color: #272727;\n}\n\n.iconpop:hover {\n  opacity: 0.6;\n  transform: scale(1.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
